import Head from 'next/head'
import Image from 'next/image'
import Nav from '@/components/Nav';
import Footer from '@/components/Footer';
import groq from 'groq';
import client from '../sanity_client';
import {urlFor} from '../sanity_image';
import {toHTML} from '@portabletext/to-html';
import React, { useState, useEffect } from "react";
import Banner from '@/components/PageBanner';
import ContactForm from '@/components/ContactForm';
import $ from 'jquery';

export default function FindAPartner({pageContent, partners, siteSettings}:any) {

  function setGoogleMap() {
    // @ts-ignore
    google.charts.load('current', {
      'packages': ['geochart'],
      // Note: you will need to get a mapsApiKey for your project.
      // See: https://developers.google.com/chart/interactive/docs/basic_load_libs#load-settings
      'mapsApiKey': 'AIzaSyBaGOb-h8cjNuVT9v2x3rhcAOED5LVOaY8'
    });
   // @ts-ignore
    google.charts.setOnLoadCallback(drawMarkersMap);

    function drawMarkersMap() {
      // Prepare data for both US and Canada
      const allPartnerData: Array<{lat: number, long: number, id: string, value: number}> = [];
      $('.partner-office').each(function () {
        const id    = $(this).attr('data-id');
        const longStr  = $(this).attr('data-longitude');
        const latStr   = $(this).attr('data-latitude');
        const value = $(this).attr('data-description');
        
        if (longStr && latStr && id) {
          const long = parseFloat(longStr);
          const lat = parseFloat(latStr);
          allPartnerData.push({lat, long, id, value: 10});
        }
      });

      // Separate US and Canada data (rough latitude boundary at 49°N)
      const usData = allPartnerData.filter(partner => partner.lat < 49);
      const canadaData = allPartnerData.filter(partner => partner.lat >= 49);


      // Always draw US Map
      // @ts-ignore
      var usDataTable = new google.visualization.DataTable();
      usDataTable.addColumn('number', 'Lat');                                
      usDataTable.addColumn('number', 'Long');
      usDataTable.addColumn('string','Id');
      usDataTable.addColumn('number','Value');
      
      usData.forEach(partner => {
        usDataTable.addRow([partner.lat, partner.long, partner.id, partner.value]);
      });
      
      const usOptions = {
        resolution: 'provinces',
        displayMode: 'markers',
        colors: ['#b93838'],
        dataMode: 'text',
        region: 'US',
        width: 500,
        height: 350,
        legend: 'none',
        tooltip: {
          trigger: 'none'
        }
      };
      // @ts-ignore
      const usChart = new google.visualization.GeoChart(document.getElementById('us_chart_div'));
      
      if (usData.length > 0) {
        // @ts-ignore
        google.visualization.events.addListener(usChart, 'select', function () {
          const selection = usChart.getSelection();
          const id = usDataTable.getValue(selection[0].row, 2);
          $('.partner-office').addClass('hidden');
          $('.office-placeholder').addClass('hidden');
          $('#office-' + id).removeClass('hidden');
        });
      }
      
      usChart.draw(usDataTable, usOptions);

      // Always draw Canada Map
      // @ts-ignore
      var canadaDataTable = new google.visualization.DataTable();
      canadaDataTable.addColumn('number', 'Lat');                                
      canadaDataTable.addColumn('number', 'Long');
      canadaDataTable.addColumn('string','Id');
      canadaDataTable.addColumn('number','Value');
      
      canadaData.forEach(partner => {
        canadaDataTable.addRow([partner.lat, partner.long, partner.id, partner.value]);
      });
      
      const canadaOptions = {
        resolution: 'provinces',
        displayMode: 'markers',
        colors: ['#b93838'],
        dataMode: 'text',
        region: 'CA',
        width: 500,
        height: 350,
        legend: 'none',
        tooltip: {
          trigger: 'none'
        }
      };
      // @ts-ignore
      const canadaChart = new google.visualization.GeoChart(document.getElementById('canada_chart_div'));
      
      if (canadaData.length > 0) {
        // @ts-ignore
        google.visualization.events.addListener(canadaChart, 'select', function () {
          const selection = canadaChart.getSelection();
          const id = canadaDataTable.getValue(selection[0].row, 2);
          $('.partner-office').addClass('hidden');
          $('.office-placeholder').addClass('hidden');
          $('#office-' + id).removeClass('hidden');
        });
      }
      
      canadaChart.draw(canadaDataTable, canadaOptions);
    };
    
    $(window).resize(function(){
      drawMarkersMap();
    });
  }

  useEffect(() => {
    // Only initialize map if we have valid data
    if (pageContent && pageContent.length > 0) {
      // @ts-ignore
      setGoogleMap();
    }
  }, [pageContent]);

  // Handle missing data gracefully
  if (!pageContent || pageContent.length === 0) {
    return (
      <div>
        <p>Error: Page content not found. Please check your Sanity configuration and dataset.</p>
      </div>
    );
  }

  return (
    <>
    <Head>
      <title>The Line of Sight &#8480;</title>
    </Head>
    <Nav />
    <main className="row partners-row">
      <Banner bannerHeading={pageContent[0].banner_heading} bannerSubHeading={pageContent[0].banner_sub_heading} bannerImage={urlFor(pageContent[0].banner_image).width(1920).url()} />
      <div className="col-12">
        <div className="container partner-container">
          <div className="row">
            <div className="col-12" dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].content)}}>

            </div>
            <div className="col-12 col-sm-6">
              <h3 className="text-center mb-2">Canada</h3>
              <div id="canada_chart_div" className="mb-1"></div>
              <h3 className="text-center mb-2">United States</h3>
              <div id="us_chart_div"></div>
            </div>
            <div className="col-12 col-sm-6">
              <div className="office-placeholder">
                <div className="content text-center">
                  <div className="placeholder-title" dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].placeholder_title)}}>

                  </div>
                  <div dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].placeholder_text)}}>
                  </div>
                </div>
              </div>
              {partners.map((partner:any) => (
                <div key={partner._id} 
                    id={`office-${partner._id}`}
                    className="partner-office hidden"
                    data-id={`${partner._id}`}  
                    data-name={`${partner.title}`} 
                    data-location={`${partner.location}`} 
                    data-longitude={`${partner.longitude}`}
                    data-latitude={`${partner.latitude}`}
                    data-description="description goes here">
                  <h2>LOS Practitioners across the U.S. and Canada:</h2>
                  <div className="row">
                    <div className="col-12">
                      {partner.partner_url != '' && typeof(partner.partner_url) != "undefined" ?
                        <p>{partner.location} : <a href={`${partner.partner_url}`} target="_BLANK">{partner.title}</a></p>
                      : 
                        <p>{partner.location} : {partner.title}</p>
                      } 
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8">
                      <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 image-1-container partner-image-container">
                          {partner.partner_one_image ?
                            <div className="image-div partner-image-div" style={{backgroundImage:`url(${urlFor(partner.partner_one_image).width(700).url()})`}}>

                            </div>
                          :
                            ''
                          }
                          <p className="partner-name">{partner.partner_one_name}</p>
                          <p className="partner-title">{partner.partner_one_title}</p>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 image-2-container partner-image-container">
                          {partner.partner_two_image ?
                            <div className="image-div partner-image-div" style={{backgroundImage:`url(${urlFor(partner.partner_two_image).width(700).url()})`}}>
  
                            </div>
                          :
                            ''
                          }
                          <p className="partner-name">{partner.partner_two_name}</p>
                          <p className="partner-title">{partner.partner_two_title}</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 partner-description">
                      <div>
                        {partner.summary_description}
                      </div>
                      <p><a href={`/partner/${partner.url_path}`}>Learn More</a></p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <ContactForm adminEmails={siteSettings[0].admin_emails} />
    </main>
    <Footer />
    </>
  )
}

export async function getServerSideProps() {
  const pageContent = await client.fetch(groq`*[_type == "findAPartnerPage"]`);
  const partners = await client.fetch(groq`*[_type == "partner"]`);
  const siteSettings = await client.fetch(groq`*[_type == "siteSettings"]`);
  return {
    props: {
      pageContent: pageContent,
      partners: partners,
      siteSettings: siteSettings
    }
  }
}
